import { CommonModule } from '@angular/common';
import { ThisReceiver } from '@angular/compiler';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule, RouterState, RouterStateSnapshot } from '@angular/router';
import { ChartThumbnailComponent } from 'src/app/pages/_components/chart-thumbnail/chart-thumbnail.component';
import { BannerCardComponent } from "src/app/pages/_components/banner-card/banner-card.component";

@Component({
  selector: 'app-portfolio-side-navigation',
  templateUrl: './portfolio-side-navigation.component.html',
  styleUrls: ['./portfolio-side-navigation.component.scss'],
  imports: [CommonModule, ChartThumbnailComponent, RouterModule, BannerCardComponent]
})
export class PortfolioSideNavigationComponent implements OnInit {

  portfolioNumber = "";
  @Input() charts:any;
  constructor(private router:Router, public route: ActivatedRoute) {  
    var regex = "/portfolios/([0-9]+)";
    var m = this.router.routerState.snapshot.url.match(regex);     
    if(m && m.length>1){    
     this.portfolioNumber=m[1];
    }
   }

  ngOnInit(): void {
  
  }

}
